import { useCurrentEditor as useCurrentEditorBase } from '@tiptap/react';

export const useCurrentEditor = () => {
  return useCurrentEditorBase();
};
